import { Button } from '@mantine/core';
import { primaryColor } from '../../../../constants/theme';
import { QRCodeCanvas } from 'qrcode.react';

interface DownloadQRCodeButtonProps {
  username: string;
  value: string;
  onCopyQRCode?: () => void;
}

export const DownloadQRCodeButton = ({
  username,
  value,
  onCopyQRCode,
}: DownloadQRCodeButtonProps) => {
  const onDownloadQRCode = () => {
    onCopyQRCode?.();

    const qrCanvas = document.getElementById('qr-code-canvas') as HTMLCanvasElement;
    if (qrCanvas) {
      const padding = 20;
      const logoHeight = 40;

      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = '/logo.png';

      const downloadCanvas = (canvas: HTMLCanvasElement) => {
        const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        const downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = `${username || 'profile'}-qrcode.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      };

      img.onload = () => {
        const aspect = img.width / img.height;
        const logoWidth = logoHeight * aspect;

        const textSpace = 70;
        const combinedCanvas = document.createElement('canvas');
        combinedCanvas.width = qrCanvas.width + padding * 2;
        combinedCanvas.height = qrCanvas.height + logoHeight + padding * 3 + textSpace;
        const ctx = combinedCanvas.getContext('2d');
        if (!ctx) return downloadCanvas(qrCanvas);

        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);

        const xLogo = (combinedCanvas.width - logoWidth) / 2;
        ctx.drawImage(img, xLogo, padding, logoWidth, logoHeight);
        ctx.drawImage(qrCanvas, padding, padding * 2 + logoHeight);

        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.fillStyle = '#000000';
        ctx.font = 'bold 18px Inter, system-ui, Avenir, Helvetica, Arial, sans-serif';
        const textY1 = padding * 2 + logoHeight + qrCanvas.height + 10;
        ctx.fillText('Talk To Me On CircleBe', combinedCanvas.width / 2, textY1);

        ctx.fillStyle = primaryColor;
        ctx.font = '16px Inter, system-ui, Avenir, Helvetica, Arial, sans-serif';
        const textY2 = textY1 + 24;
        ctx.fillText(`@${username || ''}`, combinedCanvas.width / 2, textY2);

        downloadCanvas(combinedCanvas);
      };

      img.onerror = () => downloadCanvas(qrCanvas);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        color={primaryColor}
        onClick={onDownloadQRCode}
        data-testid="download-qr-button"
      >
        Download QR Code
      </Button>
      <div style={{ display: 'none' }}>
        <QRCodeCanvas id="qr-code-canvas" value={value} size={256} fgColor={primaryColor} level="H" />
      </div>
    </>
  );
};
